/**
 * 场景视角模板（管理后台）
 *
 * 与角色 / 物品视角列表完全独立：用户在场景详情页生成设定图时，
 * 仅从此列表加载选项。
 */

import { directorAdminApi } from '../../../apps/director/services/directorAdminApi';
import { AngleTemplatesEditor } from './AngleTemplatesEditor';

export default function DirectorSceneAngleTemplatesTab() {
  return (
    <AngleTemplatesEditor
      title="场景视角模板"
      description={
        '用户在场景详情页生成设定图时，会从这里加载可选视角。promptSuffix 会拼到场景描述末尾用于生图。\n仅影响"场景"，与角色 / 物品视角独立。'
      }
      placeholderName="名称（如：全景 / 中景 / 俯瞰）"
      placeholderSuffix="prompt 后缀，如 ', wide establishing shot, depth of field'"
      load={() => directorAdminApi.getSceneAngleTemplates()}
      save={(t) => directorAdminApi.updateSceneAngleTemplates(t)}
    />
  );
}
